<template>
  <div class="hello" style="background-color: #F8F8F8; ">

    <el-row>
       <el-col :span="16" class="left-boy" :style="{height:bodyHeight}" >
        
       <img src="../assets/login-boy.png" class="img-fluid">
        
       </el-col>
      <el-col :span="8" class="right-login" :style="{height:bodyHeight}">
        
        <div  class="login-area" style="">
             <h5 style="font-size:24px;color:#6666ff; "><i class="el-icon-monitor" style="margin-right:10px;"></i>相亲APP后台管理</h5>

            <!-- <div class="input-wrapper" style="border:red solid 1px; height:100px;">
                  <el-input class="text-input"></el-input>
                  <label class="input-label">用户名</label>
                </div>-->

             <el-form :model="login" ref="loginForm" :rules="rules">

                <div class="input-group" style="width:100%;">
                  <el-form-item prop="loginAccount" >
                       <el-input type="text" id="loginAccount" v-model="login.loginAccount" class="input-field" placeholder=" " />
                        <label for="loginAccount" class="floating-label">用户名</label>
                  </el-form-item>
                 
                </div>

                <div class="input-group" style="margin-top:30px;width:100%;">
                  <el-form-item prop="password">
                       <el-input type="text" id="password" v-model="login.password" class="input-field" placeholder=" " />
                       <label for="password" class="floating-label">密码</label>
                  </el-form-item>
                </div>

                 <el-button type="primary" style="height:50px;margin-top:30px;width:100%; background-color:#8C57FF;" @click="submitLogin">登录</el-button>
              </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>

var _this;
export default {
  name: 'Login',
  data () {

      var checkLoginAccount = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('用户名不能为空！'));
        }
        
      };

      var checkPassword = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('用户名不能为空！'));
        }
        
      };

    return {
      login:{loginAccount:"",password:""},
      bodyHeight: 0,
      msg: 'Welcome to Your Vue.js App',
      rules: {
       loginAccount: [
        { 
          required: true, 
          message: '请输入用户名', 
          trigger: 'blur' 
        }
      ],
      password: [
        { 
          required: true, 
          message: '请输入密码', 
          trigger: 'blur' 
        }
      ]
      }
      
    }
  }, mounted(){
      
      window.addEventListener('resize',function(){

        let clientHeight = document.documentElement.clientHeight;
        _this.bodyHeight = clientHeight+"px";
        //alert("test");
      },300)


  },created: function () {
      _this = this;
        let clientHeight = document.documentElement.clientHeight;
        this.bodyHeight = clientHeight+"px";
     },methods:{

       async submitLogin(){

         try {
          
           // 先验证表单
    const isValid = await this.$refs.loginForm.validate();
    
    if (isValid) {
                  const paramData = _this.login;
                  
                  const response = await _this.$http.syncPost('/login/submit', paramData);
                  
                  console.info('请求结果1:', response )
                  if(response.status == 'success'){

                     _this.$http.setAuthToken(response.data);
                      //auth-token 
                      this.$router.push('layout');

                  }

                  console.log('POST请求成功:', response);


    }else{

       console.log('error submit!!');
       return false;

    }
            
            // 如果登录成功，保存token
            //if (response.data && response.data.token) {
             // this.$http.setAuthToken(response.data.token, true); // 记住登录
            //}

           
          } catch (error) {
            console.error('请求失败:', error)
          }

        //
      }

     }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only :style="{height:bodyHeight}"-->
<style scoped>
* {
  box-sizing: border-box;
}
.left-boy{
  display:flex; 
  flex-direction:column; 
  justify-content: center; 
  align-items:center;
 
}
.img-fluid {
   max-width: 100%;
   height: auto;
}

.right-login{
  
  background-color:#ffffff;
  padding-top:10%;
  padding-left:20px;
  padding-right:20px;
}
.login-area{
  width:100%;
  max-width:500px;
  margin:0px auto;
  
}
  h5{
    text-align: left;
  }
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}



</style>



// WEBPACK FOOTER //
// src/components/Login.vue